import React from 'react';

const IconSelectorModal = ({ 
  onSelectIcon, 
  onClose 
}) => {
  const popularIcons = [
    'fa-brands fa-facebook', 
    'fa-brands fa-twitter', 
    'fa-brands fa-instagram', 
    'fa-brands fa-linkedin', 
    'fa-brands fa-youtube', 
    'fa-brands fa-tiktok', 
    'fa-brands fa-whatsapp', 
    'fa-brands fa-telegram', 
    'fa-brands fa-discord', 
    'fa-brands fa-github', 
    'fa-brands fa-pinterest', 
    'fa-brands fa-snapchat', 
    'fa-solid fa-envelope', 
    'fa-solid fa-phone', 
    'fa-solid fa-link', 
    'fa-solid fa-globe',
    'fa-solid fa-folder',
    'fa-solid fa-image', 
    'fa-solid fa-video', 
    'fa-solid fa-music', 
    'fa-solid fa-heart', 
    'fa-solid fa-star', 
    'fa-solid fa-user', 
    'fa-solid fa-camera',
    'fa-solid fa-calendar', 
    'fa-solid fa-comment', 
    'fa-solid fa-shopping-cart', 
    'fa-solid fa-home'
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium">Selectează o Iconiță</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            Iconițe populare (click pentru a selecta):
          </p>
          <div className="grid grid-cols-6 gap-4">
            {popularIcons.map((icon, index) => (
              <div 
                key={index} 
                onClick={() => onSelectIcon(icon)}
                className="p-3 border rounded hover:bg-blue-100 cursor-pointer flex flex-col items-center"
              >
                <i className={`${icon} text-2xl mb-2`}></i>
                <span className="text-xs text-gray-500 text-center truncate w-full">{icon}</span>
              </div>
            ))}
          </div>
        </div>
        
        <div className="mt-6 border-t pt-4">
          <p className="text-sm text-gray-600 mb-2">
            Ai nevoie de alte iconițe? Vizitează 
            <a 
              href="https://fontawesome.com/search" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Font Awesome
            </a> 
            pentru a căuta și alte iconițe disponibile.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IconSelectorModal; 